const Footer = () => {
  return (
    <div className="attribution">
      <p className="attribution">
        Challenge by{" "}
        <a
          href="https://www.frontendmentor.io?ref=challenge"
          target="_blank"
          rel="noreferrer"
        >
          Frontend Mentor
        </a>
        . Coded by{" "}
        <a href="https://www.frontendmentor.io/profile/TravisH-bot">Travis H</a>
        .
      </p>
    </div>
  );
};

export default Footer;
